import { Dropdown } from "react-bootstrap";
import styles from "./keyfobcard.module.css";
import { Link } from "react-router-dom";
import { MoreVertical, Trash2 } from "react-feather";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black,
        fontSize: 13,
    },
}));

const KeyfobCard = ({ item, setDeleteModalOpen, setDeleteCardNumber }) => {
    return <Link to={"/smart-devices/keyfobs/details/" + item?.card_number} className={`${styles.ProspectCard}`}>
        <div className={`${styles.ProspectCardUnder}`}>
            <div className={`${styles.ProspectCardHeadSection}`}>
                <Dropdown className={`${styles.ActionLeaseBUSec}`} onClick={(e) => { e.preventDefault(); }}>
                    <Dropdown.Toggle className={`${styles.ActionsLeaseBU} ActionsBU`} id="dropdown-basic">
                        <MoreVertical />
                    </Dropdown.Toggle>

                    <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                        <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { setDeleteModalOpen(true); setDeleteCardNumber(item?.card_number); }}>
                            <Trash2 /> Delete
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
                <div className={`${styles.ProsIMGSec}`}>
                    <img src="/static/img/door-key-icon.svg" className={`${styles.ProspectCardImg}`} alt="" />
                </div>
                <div className={`${styles.HeadConSec}`}>
                    <p className={`${styles.ProsUserName}`}>
                        <span className={`${styles.UserName}`}>{item?.card_name}</span>
                    </p>
                    <p className={`${styles.ProsUserName}`}>{item?.card_number}</p>
                </div>
            </div>
            <div className={`${styles.ProspectCardBodySec}`}>
                <ul>
                    <li>
                        <p className={`${styles.Title}`}>Type:</p>
                        <p className={`${styles.Content}`}>{item?.card_type}</p>
                    </li>
                    <li>
                        <p className={`${styles.Title}`}>Associated Lock:</p>
                        <p className={`${styles.Content}`}>
                            {item?.associated_locks?.length > 0 && <BootstrapTooltip title={(<div className={`${styles.TooltipListRow}`}>
                                {item?.associated_locks?.map((i, ind) => {
                                    return <div className={`${styles.TooltipList}`}>#{ind + 1}: {i}</div>
                                })}
                            </div>)}>
                                {item?.associated_locks[0]}
                                {item?.associated_locks?.length > 1 && <span className={`${styles.MorePropertyBU}`}>+{item?.associated_locks?.length - 1}</span>}
                            </BootstrapTooltip>}
                        </p>
                    </li>
                </ul>
            </div>
        </div>
    </Link>
}

export default KeyfobCard;